import Vue from 'vue'
import Clickblock from './clickblock'

// THIS FOLDER IS FOR SMALL COMPONENTS THAT CAN BE REUSED IN THE ENTIRE APPLICATION ONLY!

Vue.component('clickblock', Clickblock)
